<template>
<div class="video-player" ref="playContainer" :class="{'isshowmask': isOpenShare || !onLine}">
    <Xgplayer id="HF" :config="Videoconfig" @player="Player = $event" class="video-file" :class="startStyle" />
    <!-- 网络是否为Wifi Begin -->
    <div class="bg" v-if="!isWifi">
        <div class="wifidetail">
            <p>正在使用非WIFI网络</p>
            <p>视频总长01:35 请注意流量消耗</p>
            <div id="playVideo" @click="playVideoStart()">
                <img src="@/assets/img/playVideo.png" />
            </div>
        </div>
    </div>
    <!-- 网络是否为Wifi Over -->
</div>
</template>

<script>
import Xgplayer from "xgplayer-vue";
import {
    Toast,
    Dialog
} from "mand-mobile";

export default {
    name: "videoPlayer",
    components: {
        Xgplayer,
        [Dialog.name]: Dialog,
    },
    props: ["isOpenShare"],
    data() {
        return {
            prevTime: null, // 记录上次的时间
            prevTime20: null, // 记录播放到20s之后
            Player: null, //播放器实例
            isPlayerEnd: false,
            Videoconfig: {
                id: "HF", //元素id
                // "fitVideoSize":"fixWidth",
                // "fitVideoSize":"fixHeight",
                // url: "//feihe-coa-1253290912.cos.ap-beijing.myqcloud.com/coa/208/f5700643-ed24-44cc-85b2-57c7729d2397.video.mp4", //视频地址
                // poster: "//media-coa.feihe.com/coa/1/4650b2ae-fe78-435d-b2e8-12a99e4897d2.png", //图片
                url: "http://active-bucket.feihe.com/%E5%86%85%E5%AE%B9%E8%A3%82%E5%8F%98-8.10%E5%AE%9E%E9%AA%8C%E5%AE%A4%E6%B8%85%E6%99%B0%E7%89%88-28.mp4?Expires=2227839886&OSSAccessKeyId=LTAI4GBbUqkVWbd4bLQEJbXH&Signature=uL11Rdu5nXrdSnJpMk1Z1cLc8DA%3D",
                poster: "https://active-bucket.feihe.com/1bbbf0456e8847f8a0022e5b4b993628.png?Expires=2224912712&OSSAccessKeyId=LTAI4GBbUqkVWbd4bLQEJbXH&Signature=nboJL0qUTVRc2fwLWvUAL87F%2FQc%3D",
                fluid: true,
                playsinline: true, //设置ios全屏问题
                "x5-video-player-type": "h5-page", //解决ios安卓播放自动全屏问题
                "x5-video-player-fullscreen": true, //解决自动全屏问题
                "x5-video-orientation": "portraint", //横竖屏
                closeVideoClick: true, //禁止pc点击屏幕暂停（功能与现实相反）
                closeVideoTouch: true, //禁止手机点击屏幕暂停（功能与现实相反）
                ignores: ["enter", "mobile", "error"], //去掉loadding
                loop: false, //循环播放
                whitelist: ["iPhone", "Android"], //白名单（支持个别机型）
                hasStart: true,
            },
            isWifi: true,
            onLine: navigator.onLine,
            domFlag: true,
            // appleVideoStarted: false,
            // appleResize: false,
            // bodycurrentheight: document.body.clientHeight
        };
    },
    computed: {
        // 计算视频带不带播放按钮
        startStyle() {
            if (!this.isWifi) {
                return "xgplayer xgplayer-mobile xgplayer-skin-default lang-is-en  xgplayer-playing xgplayer-inactive xgplayer-pause videoDisPlayer";
            } else {
                return "xgplayer xgplayer-mobile xgplayer-skin-default xgplayer-pause  lang-is-en xgplayer-playing";
            }
        },
    },
    watch: {
        isOpenShare: {
            immediate: true, //这句重要
            deep: true, //深监听
            handler(newValue) {
                console.log(newValue);
                if (newValue) {
                    this.Player.pause();
                }
            },
        },
        onLine: {
            immediate: true, //这句重要
            deep: true, //深监听
            handler(newValue) {
                console.log(newValue);
                if (!newValue) {
                    this.Player.pause();
                }
            },
        },
    },
    mounted() {
        // 记录页面的高度，当页面高度与记录的高度不一致时，改变app的高度，因为app页面时定位到底部，所以页面看上去不会被截取掉
        if (!localStorage.getItem("bodyheight")) {
            localStorage.setItem("bodyheight", document.body.clientHeight);
        }
        if (localStorage.getItem("bodyheight") != document.body.clientHeight) {
            document.getElementById("app").style.height =
                Math.min(localStorage.getItem("bodyheight"), window.innerHeight) + "px";
        }
        // 监听横屏后视频全屏
        window.onresize = this.renderResize;
        // window.addEventListener('resize', this.renderResize, false)

        // 监听网络由正常变为异常时弹出框
        window.addEventListener("online", this.online); // 网络由正常常到异常时触发

        // 监听网络由正常变为异常时弹出框
        // window.addEventListener("offline", this.updateOnlineStatus); // 网络由正常常到异常时触发
        this.isWifiFun();
        console.log(this.isWifi);
        this.playMediaRecord(11005); // 未播放视频
        this.$nextTick(() => {
            this.renderResize();
            this.Player.on("play", this.playFile);
            this.Player.on("ended", this.ended);
            this.Player.on("pause", this.pause);
            this.Player.on("timeupdate", this.timeupdate);
        });
    },
    methods: {
        renderResize() {
            let width = document.documentElement.clientWidth;
            let height = document.documentElement.clientHeight;
            console.log( document.documentElement.clientWidth)
            if(width > 500) {
              document.querySelector('.video-file').style.height = document.body.clientHeight + 'px';
              document.querySelector('.video-file').style.width = document.body.clientWidth + 'px'
            }
            console.log(width, height);
            if (width > height) {
                this.domFlag = false
                this.$emit('DOMFLAG', this.domFlag, true);
                // this.Player.getFullscreen(this.$refs.playContainer)
                if (!this.Player.hasStart) {
                    // this.Player.destroy()
                    this.isWifi = true;
                    this.Player.start(this.Videoconfig.url);
                    // alert(this.Player.networkState)
                    this.$nextTick(() => {
                        // this.Player.reload()
                        this.Player.getCssFullscreen();
                        // alert(this.Player.networkState)
                        if (document.querySelector(".xgplayer-fullscreen")) {
                            document.querySelector(".xgplayer-fullscreen").style.display =
                                "none";
                        }
                    });
                } else {
                    this.Player.getCssFullscreen();
                    if (document.querySelector(".xgplayer-fullscreen")) {
                        document.querySelector(".xgplayer-fullscreen").style.display =
                            "none";
                    }
                }
            } else {
              this.domFlag = true
              this.$emit('DOMFLAG', this.domFlag, true);
                this.Player.exitCssFullscreen();
                if (document.querySelector(".xgplayer-fullscreen")) {
                    document.querySelector(".xgplayer-fullscreen").style.display =
                        "block";
                }
            }
        },
        online(e) {
            const {
                type
            } = e;
            this.onLine = type === "online";
        },
        updateOnlineStatus(e) {
            const {
                type
            } = e;
            this.onLine = type === "online";
            console.log("网络由正常常到异常时触发");
            if (!this.onLine) {
                Dialog.closeAll();
                Dialog.alert({
                    title: "网络未连接",
                    content: "请确认网络是否连接正常后刷新页面",
                    confirmText: "确定",
                    onConfirm: () => {
                        location.reload();
                    },
                });
            }
        },
        // 点击播放时，埋点
        playFile() {
            this.renderResize();
            window.addEventListener("offline", this.updateOnlineStatus); // 网络由正常常到异常时触发
            // console.log("点击播放", this.Player.currentTime)
            var currentTime = Math.round(this.Player.currentTime);
            if (currentTime != this.prevTime && currentTime <= 0) {
                this.$set(this, "prevTime", currentTime);
                console.log("只有一次，开始播放时埋点");
                // 重播
                if (this.isPlayerEnd) {
                    this.playMediaRecord(11002);
                } else {
                    // 首次播放
                    this.playMediaRecord(11001);
                }
            }
        },
        // 视频播放结束，进行埋点
        ended(e) {
            // 首次播放之后，播放完次数+1
            if (!this.isPlayerEnd) {
                // 完全播放
                this.playMediaRecord(11003);
            }
            // console.log("播放结束，埋点");
            this.prevTime = null;
            this.isPlayerEnd = true;
        },
        pause() {
            // 视频暂停时，当页面高度与记录的高度不一致时，改变app的高度，因为app页面时定位到底部，所以页面看上去不会被截取掉
            if (localStorage.getItem("bodyheight") != document.body.clientHeight) {
                document.getElementById("app").style.height =
                    Math.min(localStorage.getItem("bodyheight"), window.innerHeight) +
                    "px";

            }
        },
        timeupdate() {
            var currentTime = Math.round(this.Player.currentTime);
            if (currentTime != this.prevTime20 && currentTime >= 20) {
                if (!this.prevTime20) {
                    console.log("大于20s，只有一次，");
                    this.playMediaRecord(11004);
                }
                this.$set(this, "prevTime20", currentTime);
            }
        },
        exitFullscreen(e) {
            alert("exitFullscreen");
        },
        playMediaRecord(type) {
            // this.$axios.defaults.showloading = false;
            // showloading: false
            this.$axios
                .post("/fission-video/fissionVideo/playMedia", {
                    type: type,
                    hideloading: true,
                })
                .then((res) => {})
                .catch((error) => {});
        },
        playVideoStart() {
            this.isWifi = true;
            this.Player.start(this.Videoconfig.url);
            this.Player.play();
        },
        /**
         * @description: 判断网络是否为wifi
         * @param {type} isWifi 网络状态
         * @return: isWifi 网络状态
         */
        isWifiFun() {
            let network_state = "";
            let ua = window.navigator.userAgent;
            let con = window.navigator.connection;
            // 如果是微信
            if (/MicroMessenger/.test(ua)) {
                // 如果是微信6.0以上版本，用UA来判断
                if (/NetType/.test(ua)) {
                    var type = ua.match(/NetType\/(\S*)/);
                    network_state = type[1];
                    // 如果是微信6.0以下版本，调用微信私有接口WeixinJSBridge
                } else {
                    document.addEventListener(
                        "WeixinJSBridgeReady",
                        function onBridgeReady() {
                            WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
                                network_state = e.err_msg;
                            });
                        }
                    );
                }
                // 如果支持navigator.connection
            } else if (con) {
                var network = con.type;
                network_state = network;
            }
            if (network_state == "WIFI") {
                this.isWifi = true;
            } else if (network_state == undefined) {
                this.isWifi = true;
            } else {
                this.isWifi = false;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.video-player {
    position: relative;
    width: 100%;
    height: 100%;

    .videoDisPlayer {
        /deep/.xgplayer-start {
            display: none !important;
        }
    }

    .video-file {
        // position: relative;
        width: auto;
        height: 100%;
        border-radius: 13px;
    }

    .bg {
        position: absolute;
        z-index: 888;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 13px;
        overflow: hidden;
        background-size: 100% 100%;

        >div {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);
            text-align: center;

            p:nth-child(1) {
                font-size: 32px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: 40px;
                padding-top: 120px;
            }

            p:nth-child(2) {
                font-size: 24px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: 30px;
                padding-top: 20px;
            }

            div {
                width: 72px;
                padding-top: 36px;
                margin: 0 auto;

                img {
                    width: 100%;
                    height: auto;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/videoPlayer.vue